import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { GeneratedImage } from 'types'
import Styles from './PreviewImageModal.module.scss'

export const PreviewImageModal = ({
  img,
  onUseImage,
  onGenerateMoreLikeThis,
}: {
  img: GeneratedImage & { requestId: number }
  onUseImage: (img: GeneratedImage) => void
  onGenerateMoreLikeThis: (requestId: number) => void
}) => {
  const { closeModal } = useModals()

  return (
    <Modal.Root onPressOutside={closeModal} blaze size="md">
      <Modal.Header></Modal.Header>
      <Modal.Content>
        <div className={Styles.imgContainer}>
          <img src={img.url} alt={img.revisedPrompt} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.rightButtons}>
            <Button
              variant="secondary"
              size="lg"
              onPress={() => {
                onGenerateMoreLikeThis(img.requestId)
                closeModal()
              }}
            >
              Generate more like this
            </Button>
            <Button
              size="lg"
              onPress={() => {
                onUseImage(img)
                closeModal()
              }}
            >
              Use Image
            </Button>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
